// import React, { useMemo, useState } from "react";
// import ReactTable from "./components/reactTable";
// import { useQuery } from "@tanstack/react-query";
// import { Link, Outlet, useLocation } from "react-router-dom";
// import { getPrices } from "../../api";
// import LineChart from "./components/LineChart";
// import BarChart from "./components/BarChart";
// import ReactSelect from "react-select";
// import Client from "../../utils/client";
// import { dropdownStyles } from "../buy/buy";
// import yearlyData from "../prices/tableConvert.com_2p1qty.json";
// import ReactGA from "react-ga4";
// import { Helmet } from "react-helmet";

// function Price() {
//   const [market, setMarket] = useState();
//   const [product, setProduct] = useState();
//   ReactGA.send({
//     hitType: "pageview",
//     page: window.location.pathname,
//     title: "Statistics",
//   });

//   const { data: prices } = useQuery({
//     queryKey: ["prices"],
//     queryFn: () => getPrices(),
//     initialData: [],
//   });
//   const data = useMemo(() => prices);
//   const products = {};

//   yearlyData.map((e) => (products[e["Product Ar"]] = e["Product Ar"]));

//   const fake = [...yearlyData];

//   function calculateAverageWithoutZeros(...prices) {
//     const filteredPrices = prices.filter((price) => price !== 0);

//     if (filteredPrices.length === 0) {
//       return 0;
//     }

//     const sum = filteredPrices.reduce((total, price) => total + price, 0);
//     return (sum / filteredPrices.length).toFixed(0);
//   }
//   const averagePrices = fake
//     .filter((e) => e["Product Ar"] === (product ? product : "البرسيم الحجازي"))
//     .map((product) => ({
//       ...product,
//       averagePrice: calculateAverageWithoutZeros(
//         Number(product["Ad Damazin"]),
//         Number(product["Al Foula"]),
//         Number(product["Al Qadarif"]),
//         Number(product["Dongola"]),
//         Number(product["Ed Daein"]),
//         Number(product["El Damer"]),
//         Number(product["El Fasher"]),
//         Number(product["El Nuhud"]),
//         Number(product["El Obeid"]),
//         Number(product["Geneina"]),
//         Number(product["Kadugli"]),
//         Number(product["Kassala"]),
//         Number(product["Kosti"]),
//         Number(product["Madani"]),
//         Number(product["Nyala"]),
//         Number(product["Om Durman"]),
//         Number(product["Om Durman, El Salam"]),
//         Number(product["Om Durman, Mowelih"]),
//         Number(product["Port Sudan"]),
//         Number(product["Rabak"]),
//         Number(product["Singa"]),
//         Number(product["Sinnar"]),
//         Number(product["Zalingei"])
//       ),
//     }));
//   /** @type import('@tanstack/react-table').ColumnDef<any> */
//   const columns = [
//     {
//       header: "التاريخ",
//       accessorFn: (row) =>
//         row.date ? new Date(row.date).toLocaleDateString() : "",
//     },
//     {
//       header: "الوحدة",
//       accessorKey: "unit",
//     },
//     {
//       header: "التغيُر",
//       cell: (info) =>
//         info ? (
//           Number(info?.getValue()?.replace("%", "")) > 0 ? (
//             <span className="before:content-['▲'] before:text-green-500 ">
//               {info.getValue()}
//             </span>
//           ) : Number(info?.getValue()?.replace("%", "")) < 0 ? (
//             <span className="before:content-['▼'] before:text-red-500 ">
//               {info.getValue()}
//             </span>
//           ) : (
//             info.getValue()
//           )
//         ) : (
//           ""
//         ),
//       accessorKey: "change",
//     },
//     {
//       header: "السعر",
//       accessorKey: "price",
//       cell: (info) =>
//         info.getValue() ? Number(info?.getValue()).toLocaleString("en-US") : "",
//     },
//     {
//       header: "المنتج",
//       accessorKey: "product",
//     },
//     {
//       header: "السوق",
//       accessorKey: "market",
//     },
//   ];
//   const markets = prices?.map((e) => e.market);
//   let uniqe = [...new Set(markets)];
//   return (
//     <div className="w-screen lg:w-full">
//       <Helmet>
//         ‍<title>الأسعار - محصول</title>‍
//         <meta property="og:site_name" content="Mahsool" />
//         <meta name="keywords" content="Mahsool Prices Statistics" />
//         <meta property="og:title" content="الأسعار - محصول" />
//         <meta property="og:description" content="mahsool" />
//         <meta property="og:locale" content="en_US" />
//         <meta property="og:type" content="website" />
//       </Helmet>
//       <div className="lg:w-[71rem] lg:mx-auto">
//         <ReactTable data={data} columns={columns} />
//       </div>
//     </div>
//   );
// }

// export default Price;
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import ReactTable from "./components/reactTable";
import { useQuery } from "@tanstack/react-query";
import { Link, Outlet, useLocation } from "react-router-dom";
import { getPrices } from "../../api";
import LineChart from "./components/LineChart";
import BarChart from "./components/BarChart";
import ReactSelect from "react-select";
import Client from "../../utils/client";
import { dropdownStyles } from "../buy/buy";
import yearlyData from "../prices/tableConvert.com_2p1qty.json";
import ReactGA from "react-ga4";
import { Helmet } from "react-helmet";

function Price() {
  const { t, i18n } = useTranslation();
  const [market, setMarket] = useState();
  const [product, setProduct] = useState();
  
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Statistics",
  });

  const { data: prices } = useQuery({
    queryKey: ["prices"],
    queryFn: () => getPrices(),
    initialData: [],
  });
  const data = useMemo(() => prices);
  const products = {};

  yearlyData.map((e) => (products[e["Product Ar"]] = e["Product Ar"]));

  const fake = [...yearlyData];

  function calculateAverageWithoutZeros(...prices) {
    const filteredPrices = prices.filter((price) => price !== 0);

    if (filteredPrices.length === 0) {
      return 0;
    }

    const sum = filteredPrices.reduce((total, price) => total + price, 0);
    return (sum / filteredPrices.length).toFixed(0);
  }
  
  const averagePrices = fake
    .filter((e) => e["Product Ar"] === (product ? product : t("pricePage.defaultProduct")))
    .map((product) => ({
      ...product,
      averagePrice: calculateAverageWithoutZeros(
        Number(product["Ad Damazin"]),
        Number(product["Al Foula"]),
        Number(product["Al Qadarif"]),
        Number(product["Dongola"]),
        Number(product["Ed Daein"]),
        Number(product["El Damer"]),
        Number(product["El Fasher"]),
        Number(product["El Nuhud"]),
        Number(product["El Obeid"]),
        Number(product["Geneina"]),
        Number(product["Kadugli"]),
        Number(product["Kassala"]),
        Number(product["Kosti"]),
        Number(product["Madani"]),
        Number(product["Nyala"]),
        Number(product["Om Durman"]),
        Number(product["Om Durman, El Salam"]),
        Number(product["Om Durman, Mowelih"]),
        Number(product["Port Sudan"]),
        Number(product["Rabak"]),
        Number(product["Singa"]),
        Number(product["Sinnar"]),
        Number(product["Zalingei"])
      ),
    }));
    
  /** @type import('@tanstack/react-table').ColumnDef<any> */
  const columns = [
    {
      header: t("pricePage.columns.date"),
      accessorFn: (row) =>
        row.date ? new Date(row.date).toLocaleDateString(i18n.language === 'ar' ? 'ar-SA' : 'en-US') : "",
    },
    {
      header: t("pricePage.columns.unit"),
      accessorKey: "unit",
    },
    {
      header: t("pricePage.columns.change"),
      cell: (info) =>
        info ? (
          Number(info?.getValue()?.replace("%", "")) > 0 ? (
            <span className="before:content-['▲'] before:text-green-500 ">
              {info.getValue()}
            </span>
          ) : Number(info?.getValue()?.replace("%", "")) < 0 ? (
            <span className="before:content-['▼'] before:text-red-500 ">
              {info.getValue()}
            </span>
          ) : (
            info.getValue()
          )
        ) : (
          ""
        ),
      accessorKey: "change",
    },
    {
      header: t("pricePage.columns.price"),
      accessorKey: "price",
      cell: (info) =>
        info.getValue() ? Number(info?.getValue()).toLocaleString(i18n.language === 'ar' ? 'ar-EG' : 'en-US') : "",
    },
    {
      header: t("pricePage.columns.product"),
      accessorKey: "product",
    },
    {
      header: t("pricePage.columns.market"),
      accessorKey: "market",
    },
  ];
  
  const markets = prices?.map((e) => e.market);
  let uniqe = [...new Set(markets)];
  
  return (
    <div className="w-screen lg:w-full">
      <Helmet>
        <title>{t("pricePage.meta.title")}</title>
        <meta property="og:site_name" content="Mahsool" />
        <meta name="keywords" content={t("pricePage.meta.keywords")} />
        <meta property="og:title" content={t("pricePage.meta.title")} />
        <meta property="og:description" content={t("pricePage.meta.description")} />
        <meta property="og:locale" content={i18n.language === 'ar' ? 'ar_SA' : 'en_US'} />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className="lg:w-[71rem] lg:mx-auto">
        <ReactTable data={data} columns={columns} />
      </div>
    </div>
  );
}

export default Price;